module.exports = __webpack_public_path__ + "img/whitehand.3d0c1eec.svg";